import { Params } from '@angular/router';
import {
  getSegments,
  OrdersSegment
} from '../../data/gameDay-data.segmentations';
import { GameDayCalculatedData } from '../../data/gameDay-data.calculation';
import { DealSummary } from '../../models/deal-summary';
import { GameDayModel } from '../../../models/gameday-model';

function calculateFillPercentage(
  segments: OrdersSegment<any>[],
  firstDate: Date,
  lastDate?: Date
): number {
  const _segments: OrdersSegment<any>[] = segments.filter(
    (segment: OrdersSegment<any>) => {
      const date = segment.maturities[0].maturityDate.toDate();
      return date >= firstDate && (lastDate ? date < lastDate : true);
    }
  );

  const { size, amount } = _segments.reduce(
    (prev: { size: number; amount: number }, segment: OrdersSegment<any>) => ({
      size: prev.size + segment.maturities[0].size,
      amount: prev.amount + segment.value
    }),
    { size: 0, amount: 0 }
  );

  return _segments.length !== 0 ? (amount / size) * 100 : undefined;
}

function maturityByDateComparatorAsc(
  { maturityDate: date1 }: GameDayModel.Maturity,
  { maturityDate: date2 }: GameDayModel.Maturity
): number {
  const number1 = date1.toDate();
  const number2 = date2.toDate();
  if (+number1 > +number2) {
    return 1;
  }
  if (+number1 < +number2) {
    return -1;
  }
  return 0;
}

export function calculateSummary({
  deal,
  orders
}: GameDayCalculatedData): DealSummary {
  const size = deal.maturities
    .map((m) => m.size)
    .reduce((prevSize, maturitySize) => prevSize + maturitySize, 0);
  const startDate: Date = deal.expectedPricingDate.toDate();
  const shortDate: Date = new Date(startDate.getTime());
  const midDate: Date = new Date(startDate.getTime());
  let fill = 0;
  let amount = 0;

  deal.maturities = deal.maturities.slice().sort(maturityByDateComparatorAsc);

  shortDate.setFullYear(startDate.getFullYear() + 10);
  midDate.setFullYear(startDate.getFullYear() + 20);

  const segments: OrdersSegment<any>[] = getSegments(orders, deal.maturities, [
    {
      id: (maturity: GameDayModel.Maturity) => maturity.id.toString(),
      value: () => 0,
      mapper: (segment: OrdersSegment<any>): OrdersSegment<any> => {
        const segmentSize: number = segment.maturities[0].size;
        const segmentAmount: number = segment.orders.reduce(
          (prevAmount: number, order: GameDayModel.Order) =>
            prevAmount + order.amount,
          0
        );

        segment.value +=
          segmentSize < segmentAmount ? segmentSize : segmentAmount;

        amount += segmentAmount;
        fill += segment.value;

        return segment;
      }
    }
  ]);

  const balance: number = size - fill;

  return {
    balance: balance / 1000,
    subscription: amount / size,
    amount: amount / 1000,
    fill: fill / 1000,
    fillPercent: amount !== 0 ? (fill / size) * 100 : 0,
    shortPercent: calculateFillPercentage(segments, startDate, shortDate),
    midPercent: calculateFillPercentage(segments, shortDate, midDate),
    longPercent: calculateFillPercentage(segments, midDate)
  };
}

// ToDo: Remove later, obsolete
export function getMonitorQueryParams(queryParams: Params) {
  return {
    ...queryParams
  };
}
